import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'semantic-ui-css/semantic.min.css'
import { Neo4jProvider, createDriver } from 'use-neo4j'

//const driver = createDriver('neo4j', '34.236.156.20', 7687, 'neo4j', '2xHT0cKL9fVK92pJ30Vp')
// const driver = createDriver('bolt', 'localhost', 7687, 'neo4j', '2xHT0cKL9fVK92pJ30Vp')

//const driver = createDriver('neo4j', 'lineage.bigabidserv.com', 7687, 'data_lineage', 'zb3zUCxeW8aAz368fzdBDNqUzGqy8')
const driver = createDriver('bolt+ssc', 'lineage.bigabidserv.com', 7687, 'data_lineage', 'zb3zUCxeW8aAz368fzdBDNqUzGqy8')

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
    <Neo4jProvider driver={driver}>
        <App />
    </Neo4jProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
